module.exports = __webpack_public_path__ + "img/banner.3172c176.jpg";